<template>
  <div class="page-box" style="position: relative;">
    <el-form ref="temporaryWorkFilter" :model="temporaryWork" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350"
        @search="refreshTemporaryWork(true)"
        @reset="onResetTemporaryWork"
      >
        <el-form-item label="要求完成时间" prop="formFilter.createTime">
          <date-range class="filter-item" v-model="temporaryWork.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
                      range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
                      format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="工作标题" prop="formFilter.workSubject">
          <el-input class="filter-item" v-model="temporaryWork.formFilter.workSubject"
            :clearable="true" placeholder="工作标题"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetTemporaryWork">重置</el-button>

        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshTemporaryWork(true)">查询
        </el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize" :disabled="!checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkAdd')"
                   @click="onTemporaryWorkAddClick()">
          新增
        </el-button>
      </filter-box>
    </el-form>
      <el-table ref="temporaryWork" header-cell-class-name="table-header-gray"
        :data="temporaryWork.TemporaryWork.impl.dataList" :size="defaultFormItemSize"
        @sort-change="temporaryWork.TemporaryWork.impl.onSortChange"
        @refresh="refreshTemporaryWork(true)"
      >
        <!-- 表格操作 -->

        <!-- 表格列 -->
        <el-table-column label="序号" type="index" width="50px" :index="temporaryWork.TemporaryWork.impl.getTableIndex" />
        <el-table-column label="工作标题" prop="workSubject" />
<!--        <el-table-column label="创建人" prop="createUserId" />-->
        <el-table-column label="要求完成时间" prop="requiredTime">
          <template slot-scope="scope">
            <span>{{formatDateByStatsType(scope.row.requiredTime, 'day')}}</span>
          </template>
        </el-table-column>b
        <el-table-column v-if="userInfo.isSpecial && (userInfo.isSpecial ==='1' || userInfo.isSpecial ==='2')"
                         label="反馈情况" prop="feedback" />
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button @click.stop="onTemporaryWorkUpdateClick(scope.row)" type="text" :size="defaultFormItemSize"
              :disabled="!checkPermCodeExist('temporaryWorkList:temporaryWork:temporaryWorkUpdate')">
              查看编辑
            </el-button>
            <el-button @click.stop="onTemporaryWorkUpdateClick(scope.row)" type="text" :size="defaultFormItemSize"
                       >
              查看反馈
            </el-button>
            <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
              :disabled="!checkPermCodeExist('temporaryWorkList:temporaryWork:delete')">
              删除
            </el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <div class="table-empty unified-font">
            <img src="@/assets/img/empty.png">
            <span>暂无数据</span>
          </div>
        </template>
      </el-table>
        <!-- 分页 -->
        <el-row slot="pagination" type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="temporaryWork.TemporaryWork.impl.totalCount"
            :current-page="temporaryWork.TemporaryWork.impl.currentPage"
            :page-size="temporaryWork.TemporaryWork.impl.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="temporaryWork.TemporaryWork.impl.onCurrentPageChange"
            @size-change="temporaryWork.TemporaryWork.impl.onPageSizeChange">
          </el-pagination>
        </el-row>

  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { TemporaryWorkController, DictionaryController } from '@/api';

export default {
  name: 'temporaryWorkList',
  props: {
    id: {
      default: undefined
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      temporaryWork: {
        formFilter: {
          createTime: undefined,
          workSubject: undefined
        },
        formFilterCopy: {
          createTime: undefined,
          workSubject: undefined
        },
        TemporaryWork: {
          impl: new TableWidget(this.loadTemporaryWorkWidgetData, this.loadTemporaryWorkVerify, true, false)
        },
        isInit: false
      },
      userInfo: {}
    }
  },
  methods: {
    onResetTemporaryWork () {
      this.$refs.temporaryWorkFilter.resetFields();
      this.refreshTemporaryWork(true);
    },
    /**
     * 临时性工作数据获取函数，返回Promise
     */
    loadTemporaryWorkWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        temporaryWorkDtoFilter: {
          createTimeStart: Array.isArray(this.temporaryWork.formFilterCopy.createTime) ? this.temporaryWork.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.temporaryWork.formFilterCopy.createTime) ? this.temporaryWork.formFilterCopy.createTime[1] : undefined,
          workSubject: this.temporaryWork.formFilterCopy.workSubject
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        TemporaryWorkController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 临时性工作数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadTemporaryWorkVerify () {
      this.temporaryWork.formFilterCopy.createTime = this.temporaryWork.formFilter.createTime;
      this.temporaryWork.formFilterCopy.workSubject = this.temporaryWork.formFilter.workSubject;
      return true;
    },
    /**
     * 更新临时工作
     */
    refreshTemporaryWork (reloadData = false) {
      if (reloadData) {
        this.temporaryWork.TemporaryWork.impl.refreshTable(true, 1);
      } else {
        this.temporaryWork.TemporaryWork.impl.refreshTable();
      }
      if (!this.temporaryWork.isInit) {
        // 初始化下拉数据
      }
      this.temporaryWork.isInit = true;
    },
    /**
     * 添加
     */
    onTemporaryWorkAddClick () {
      let params = {};

      params.closeVisible = 1;
      this.$router.push({name: 'temporaryWorkForm', query: params});
    },
    /**
     * 修改
     */
    onTemporaryWorkUpdateClick (row) {
      let params = {
        id: row.id
      };

      params.closeVisible = 1;
      this.$router.push({name: 'temporaryWorkForm', query: params});
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };
      this.$confirm('确认删除？').then(res => {
        TemporaryWorkController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.temporaryWork.TemporaryWork.impl.refreshTable(false, 1);
        }).catch(e => {});
      }).catch(e => {});
    },
    onResume () {
      this.refreshTemporaryWork();
    },
    initFormData () {
    },
    formInit () {
      this.refreshTemporaryWork();
    }
  },
  mounted () {
    this.userInfo = this.$store.state.userInfo

    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
